/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ExecRiskAylienNewsOverviewEntry } from './ExecRiskAylienNewsOverviewEntry';
import {
    ExecRiskAylienNewsOverviewEntryFromJSON,
    ExecRiskAylienNewsOverviewEntryFromJSONTyped,
    ExecRiskAylienNewsOverviewEntryToJSON,
} from './ExecRiskAylienNewsOverviewEntry';

/**
 * 
 * @export
 * @interface ExecRiskPaginatedAylienResponse
 */
export interface ExecRiskPaginatedAylienResponse {
    /**
     * 
     * @type {number}
     * @memberof ExecRiskPaginatedAylienResponse
     */
    total?: number;
    /**
     * 
     * @type {Array<ExecRiskAylienNewsOverviewEntry>}
     * @memberof ExecRiskPaginatedAylienResponse
     */
    results: Array<ExecRiskAylienNewsOverviewEntry>;
    /**
     * 
     * @type {string}
     * @memberof ExecRiskPaginatedAylienResponse
     */
    schema_version?: string;
    /**
     * 
     * @type {number}
     * @memberof ExecRiskPaginatedAylienResponse
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof ExecRiskPaginatedAylienResponse
     */
    page_size?: number;
}

/**
 * Check if a given object implements the ExecRiskPaginatedAylienResponse interface.
 */
export function instanceOfExecRiskPaginatedAylienResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "results" in value;

    return isInstance;
}

export function ExecRiskPaginatedAylienResponseFromJSON(json: any): ExecRiskPaginatedAylienResponse {
    return ExecRiskPaginatedAylienResponseFromJSONTyped(json, false);
}

export function ExecRiskPaginatedAylienResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExecRiskPaginatedAylienResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'total': !exists(json, 'total') ? undefined : json['total'],
        'results': ((json['results'] as Array<any>).map(ExecRiskAylienNewsOverviewEntryFromJSON)),
        'schema_version': !exists(json, 'schema_version') ? undefined : json['schema_version'],
        'page': !exists(json, 'page') ? undefined : json['page'],
        'page_size': !exists(json, 'page_size') ? undefined : json['page_size'],
    };
}

export function ExecRiskPaginatedAylienResponseToJSON(value?: ExecRiskPaginatedAylienResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'total': value.total,
        'results': ((value.results as Array<any>).map(ExecRiskAylienNewsOverviewEntryToJSON)),
        'schema_version': value.schema_version,
        'page': value.page,
        'page_size': value.page_size,
    };
}

